import { Subscription } from 'src/app/admin-api';
import { AppComponent } from 'src/app/app.component';

export enum SubscriptionEnum {
  'Glambox' = 1,
  'Glambox Premium' = 2,
  'Select' = 3,
  'Prime' = 4,
  'Glambag' = 5,
  'Glampass' = 6,
  'Glamcombo' = 7,
  'Glambag Premium' = 8,
  'Glamcombo Premium' = 9
}

export function getActiveSubscriptions(): Subscription[] {
  return AppComponent.subscriptions?.filter((s) => s.active) || [];
}

export function getAllSubscriptions(): Array<{ label: string; value: number }> {
  const subs = toDropdownArray(AppComponent.subscriptions);
  subs.sort(
    (a, b) =>
      getSubscriptionIdsByPriority().indexOf(a.value) -
      getSubscriptionIdsByPriority().indexOf(b.value)
  );
  return subs;
}

export function getAllSubscriptionsIncludeAll(): Array<{
  label: string;
  value: number;
}> {
  return includeAllSubscriptions(getAllSubscriptions());
}

export function getSubscriptionName(
  subscriptionId: number
): string | undefined {
  return (
    AppComponent.subscriptions?.find((s) => s.subscriptionId === subscriptionId)
      ?.subscriptionName || 'Não encontrado'
  );
}

export function getSubscriptionIdsByPriority(): Array<SubscriptionEnum> {
  return [
    SubscriptionEnum['Glamcombo Premium'],
    SubscriptionEnum.Glamcombo,
    SubscriptionEnum['Glambox Premium'],
    SubscriptionEnum.Glambox,
    SubscriptionEnum['Glambag Premium'],
    SubscriptionEnum.Glambag,
    SubscriptionEnum.Select,
    SubscriptionEnum.Glampass,
    SubscriptionEnum.Prime
  ];
}

function toDropdownArray(
  array: Subscription[]
): Array<{ label: string; value: number }> {
  return array.map((s) => ({
    label: s.subscriptionName,
    value: s.subscriptionId
  }));
}

function includeAllSubscriptions(
  array: Array<{ label: string; value: number }>
): Array<{ label: string; value: number }> {
  return [{ label: 'Todas', value: 0 }, ...array];
}

export function getSubscriptionImage(subscriptionId: number): string {
  const name = getSubscriptionName(subscriptionId)
    .toLowerCase()
    .replace('glam', '');
  return `https://storage.googleapis.com/b4aprodution.appspot.com/glambox/assets/images/box-home/icons/${name}-desk.webp`;
}
